<template>
  <div :class="[classes.container, 'row']">
    <img :class="classes.img" :src="image" />
    <FontFillText
      styleGroup="Casino List Game Name"
      :minSize="8"
      :maxSize="16"
      :class="[classes.gameName]"
      :text="name"
      justifyContent="center"
      alignment="flex-start"
      :getFont="text.get"
      :setFont="text.set"
    />
    <Button
      :class="[classes.button, layoutClass]"
      :optionName="name"
      :text="ctaText"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { Brand } from "@fresh8/types";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

import FontFillText from "../../../FontFillText.vue";
import Button from "../CasinoButton.vue";
import { camelize } from "@fresh8/ad-data-composition/src/lib/formatText";
import {
  injectTemplateSize,
  LARGE_MPU
} from "@fresh8/ad-data-composition/src/useTemplateSize";

const useStyles = createUseStyles({
  img: {
    height: "40px",
    aspectRatio: "1/1",
    borderRadius: "5px",
    backgroundColor: props => props.backgroundColor
  },
  container: {
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "center",
    height: "50px",
    display: "flex",
    flexDirection: "row",
    "& > * + *": {
      marginLeft: "8px"
    }
  },
  gameName: {
    boxSizing: "border-box",
    display: "flex",
    lineHeight: "1",
    alignSelf: "center",
    width: "50%",
    height: "40px !important",
    marginLeft: "8px",
    "& p": {
      textAlign: "left"
    },

    "& *": {
      verticalAlign: "middle"
    }
  },

  button: {
    //@ts-ignore
    boxSizing: "content-box !important",
    placeSelf: "center",

    padding: "2px 0 !important",
    width: "75px",

    height: "26px !important",
    "& span": {
      lineHeight: "1",
      textAlign: "center",
      fontSize: "12px !important"
    },

    [`&.${camelize(LARGE_MPU.name)}`]: {
      padding: "2px 0px !important",
      height: "initial"
    }
  }
});

export default defineComponent({
  name: "CasinoListItem",
  components: {
    FontFillText,
    Button
  },
  props: {
    image: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    ctaText: {
      type: String,
      required: true
    }
  },
  setup() {
    const brandContext = injectBrand();
    const templateContext = injectTemplateSize();

    const reactiveStyles = computed(() => ({
      backgroundColor: brandContext?.getColorStyle(
        brandContext?.adTemplate.value?.backgroundColor
      )
    }));

    const classes = useStyles(reactiveStyles);

    return {
      text: {
        get(brand: Brand | undefined) {
          if (brand) {
            return (
              brand.adTemplate.casino?.list.font ||
              brand.adTemplate.market.casinoListTextFont ||
              ""
            );
          }
        },
        set(brand: Brand, value: string) {
          if (brand.adTemplate.casino) {
            brand.adTemplate.casino.list.font = value;
          }
        }
      },
      layoutClass: computed(() => camelize(templateContext?.size.value.name)),
      classes
    };
  }
});
</script>
